import { render, staticRenderFns } from "./iconEmail.vue?vue&type=template&id=ef753340&scoped=true"
import script from "./iconEmail.vue?vue&type=script&lang=js"
export * from "./iconEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef753340",
  null
  
)

export default component.exports